<template>
  <div class="popup-overlay ">
    <div class="sensor-popup-overlay">
      <div class='popup-title flex'>
        <span>Users</span>
        <img width="20px" :src="fit20.storageBaseUrl + '/static/icons/white-x.svg'" @click="usersPopup()" />
      </div>
      <div class="sensors-body">
        <div>
          <br>
          <div class="sensor-popup">
            <div class="flex sensor-row">
              <div class="sec2">
                <input type="text" class="form-control" value='Email' disabled />
              </div>
              <div class="sec3">
                <select type="" class="form-control active-select" value='Active' disabled>
                  <option value="Active">Active</option>
                </select>
              </div>
              <div class="sec4">

                <select type="" class="form-control role-select" value='Role' disabled>
                  <option value="Role">Role</option>
                </select>
              </div>
            </div>
          </div>
          <div class="sensor-popup users-content">
            <div class="flex sensor-row" v-for="user in fit20.users">

              <div class="sec2">
                <input type="text" class="form-control" v-model="user.email" :disabled="true" />
              </div>
              <div class="sec3">
                <select type="" class="form-control active-select" v-model="user.active" :disabled="true">
                  <option :value=true>Yes</option>
                  <option :value=false>No</option>
                </select>
              </div>
              <div class="sec4">
                <select type="" class="form-control  role-select" v-model="user.role" :disabled="true">
                  <option value='super_admin'>Super admin</option>
                  <option value='admin'>Admin</option>
                </select>
              </div>
            </div>
          </div>
          <div class="sensor-popup">
            <div class="flex sensor-row ">
              <div class="sec2">
                <input type="text" class="form-control" placeholder="Email" v-model="newUser.email" />
              </div>
              <div class="sec3">
                <select type="" class="form-control active-select" v-model="newUser.active">
                  <option :value=true>Yes</option>
                  <option :value=false>No</option>
                </select>
              </div>
              <div class="sec4">
                <select type="" class="form-control  role-select" v-model="newUser.role">
                  <option value='super_admin'>Super admin</option>
                  <option value='admin'>Admin</option>
                </select>
              </div>
              <div class="sec4">
                <img width="50" @click.stop.prevent="addUser()"
                  src="https://storage.googleapis.com/fit20app-4-acctest.appspot.com/static/icons/%2B.png" />
              </div>
            </div>
          </div>
          <!-- <div class="btn-container">
            <span :class="'fit20-btn ' + (isChanged ? 'save-btn-active' : 'save-btn-disable')" @click="saveUsers()">{{
              'save'
            }}</span>
          </div> -->
          <br>
        </div>
      </div>

    </div>
  </div>
</template>
<script>
export default {
  name: 'Users',
  props: ["fit20", "usersPopup"],
  data() {
    return {
      showMenu: false,
      machines: [],
      isChanged: false,
      newUser: {
        email: '',
        active: true,
        role: 'admin'
      }
    };
  },
  methods: {
    saveUsers: async function () {
      // try {
      //   let user = await fetch(this.fit20.baseUrl + "/api/users/" + this.fit20.user.email + "?accessToken=" + localStorage.getItem('access_token'), {
      //     method: 'POST',
      //     headers: {
      //       'Content-Type': 'application/json'
      //     },
      //     body: JSON.stringify(this.newUser),
      //   });

      //   //this.fit20.users.push(JSON.parse(JSON.stringify(this.newUser)));
      // } catch (err) {
      //   window.alert("something went wrong");
      //   this.newUser.email = '';
      //   this.newUser.role = 'admin';
      // }
      this.usersPopup();
      console.log('save users');
    },
    async addUser() {
      this.newUser.email.toLowerCase();
      if (!this.newUser.email) {
        alert('The Email field is require')
      } else if (this.fit20.users.find(user => user.email == this.newUser.email.toLowerCase().trim())) {
        alert('This email is already exist!')
      } else {
        this.newUser.email.toLowerCase().trim();
        // this.fit20.users.push(JSON.parse(JSON.stringify(this.newUser)));
        try {
          let user = await fetch(this.fit20.baseUrl + "/api/users/" + this.fit20.user.email + "?accessToken=" + localStorage.getItem('access_token'), {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(this.newUser),
          });

          this.fit20.users.push(JSON.parse(JSON.stringify(this.newUser)));
        } catch (err) {
          window.alert("something went wrong");
          this.newUser.email = '';
          this.newUser.role = 'admin';
        }
        this.newUser.email = '';
        this.newUser.role = 'admin';
      }
    },
  },
};
</script>
<style>
.sensor-popup-overlay {
  width: 70%;
}

.users-content {
  max-height: 400px;
  overflow: scroll;
}

.role-select {
  width: calc(14ch);
  /* Add extra space for padding and borders */
}

.active-select {
  width: calc(10ch);
  /* Add extra space for padding and borders */
}

.sensors-body {
  background-color: white;
  z-index: 1000;
  padding: 15px 15px 0px 15px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.sensor-popup .sec1 {
  min-width: 110px;
}

/* .sensor-popup .sec2 {
  width: 200px;
} */

.sensor-popup .sec2,
.sensor-popup .sec3,
.sensor-popup .sec4 {
  margin-left: 15px;
}

.sensor-popup .sec4 .connecting {
  animation: rotate360 4s linear infinite;
}

.sensor-popup .flex {
  justify-content: center;
  justify-items: center;
  align-items: center;
}

.sensor-popup input {
  width: 250px;
  border-radius: 5px;
  border: solid 1px var(--fit20-lighter-gray);
  padding: 5px;

}

.sensor-popup input:focus {
  border: solid 1px var(--fit20-lighter-blue);
}

.sensor-row {
  height: 45px;
}

@keyframes rotate360 {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
